"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transform = require('sdp-transform');
exports.limitBandwidth = function (sdpObj, limit) {
    var video = getVideoMedia(sdpObj);
    if (video) {
        video.bandwidth = [{ limit: limit, type: 'AS' }];
    }
    return transform.write(sdpObj);
};
var getVideoMedia = function (sdpObj) {
    // Find the video media
    return getMedia(sdpObj, 'video');
};
var getMedia = function (sdpObj, mediaType) {
    // Find the media type passed
    return sdpObj.media.find(function (media) { return media.type === mediaType; });
};
